import Api, { make, Response } from 'src/services/api'

import { Asset } from 'src/types'

type Data = {
  assets: Asset[]
}

async function getAll(): Promise<Response<Asset[]>> {
  return make<Data, Asset[]>({
    axiosCall: Api.get('assets'),
    transformData: data => data.assets
  })
}

export default { getAll }
